import React from 'react';
import { toast } from 'sonner';
import PropTypes from 'prop-types';
import { uploadFileApi } from '../../api/fileApi';

class FileUploader extends React.Component {
  handleUploadButtonClick = () => {
    document.getElementById(this.props.inputId).click();
  };

    uploadFiles = async (files)=> {
      const filesArray = Array.from(files);

      try {
        for (let i = 0; i < filesArray.length; i++) {
          await uploadFileApi(filesArray[i], 'user-uploads');
        }
        return Promise.resolve('All files uploaded successfully');
      } catch (error) {
        return Promise.reject('Error uploading files: ' + error);
      }
  }
  handleFileChange = async (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      if (this.props.multiple) {
        // try {
        //   const filesArray = Array.from(files);
        //   for (let i = 0; i < filesArray.length; i++) {
        //     await uploadFileApi(filesArray[i], 'user-uploads');
        //   }
        // } catch (error) {
        //   console.log(error);
        // }
        toast.promise(
          this.uploadFiles(files),
          {
            loading: 'Uploading files...',
            success: (response) => {
              return 'Files uploaded successfully';
            },
            error: (err) => {
              return 'Failed to upload';
            },
            duration: 800
          }
        )

        // this.props.handleFileUpload(files);
      } else {
        
        toast.promise(
          uploadFileApi(files[0], 'user-uploads'),
          {
            loading: 'Loading users...',
            success: (response) => {
              return 'File uploaded successfully';
            },
            error: (err) => {
              return 'Failed to upload';
            },
            duration: 800
          }
        )
        // this.props.handleFileUpload(files[0]);
      }
    }
  };

  render() {
    const { buttonLabel, inputId, multiple } = this.props;

    return (
      <div>
        <button
          className="btn btn-default-dark"
          type="button"
          onClick={this.handleUploadButtonClick}
        >
          {buttonLabel}
        </button>
        <input
          type="file"
          id={inputId}
          style={{ display: 'none' }}
          onChange={this.handleFileChange}
          multiple={multiple} // Add this attribute
        />
      </div>
    );
  }
}

FileUploader.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  inputId: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  handleFileUpload: PropTypes.func.isRequired,
};

FileUploader.defaultProps = {
  multiple: false,
};

export default FileUploader;
